
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig = {
  name: 'DbSonEspaceSante',
  version: 2,
  objectStoresMeta: [{
    store: 'DbSonEspaceSante',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'obj', keypath: 'obj', options: { unique: false } },
      { name: 'action', keypath: 'action', options: { unique: false } },
      { name: 'time', keypath: 'time', options: { unique: false } }
    ]
  }]
};